import React, { useCallback, useContext } from "react";
import {
  useClearAllFilters,
  useNumberOfFilters,
} from "@adsk/acc-issues-core/state/issuesFetchParams/useIssueFetchParams";
import FilterButton from "@adsk/alloy-react-filter-button";
import { ActivePanelTypeContext } from "../IssuesPanel/ActivePanelTypeContext";
import { PanelType } from "../PanelType";
import { useIsIssuesEmptyState } from "@adsk/acc-issues-common/hooks/state/useIsIssuesEmptyState";

export const IssuesTableFilterButton = ({ ...props }: {}) => {
  const [activePanel, setActivePanel] = useContext(ActivePanelTypeContext);
  const onFilterButtonClicked = useCallback(() => {
    setActivePanel(
      activePanel !== PanelType.FilterPanel
        ? PanelType.FilterPanel
        : PanelType.None
    );
  }, [activePanel, setActivePanel]);
  const numberOfFilters = useNumberOfFilters();
  const clearAllFilters = useClearAllFilters();
  const isDisabled = useIsIssuesEmptyState();

  return (
    <FilterButton
      filtersOpen={activePanel === PanelType.FilterPanel}
      filtersCount={numberOfFilters}
      clearFilters={clearAllFilters}
      onClick={onFilterButtonClicked}
      disabled={isDisabled}
      {...props}
    />
  );
};
